import React, { useState } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TextField } from 'material-ui';
import LinksTags from './LinksTags';
import IconButton from 'material-ui/IconButton';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import api from 'services';

import styles from 'styles';
import _ from 'lodash';
import { addNotification } from 'actions/notifications/notifications';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const getDefaultLinkData = () => ({
    value: null,
    tags: [],
});

function AddUpdateModal({
    open, setOpen, type, toEdit = undefined, handleSearch, addNotification, fromLetter = false, handleModifyLinksList, 
}) {
    const defaultLink = getDefaultLinkData();
    if (fromLetter) {
        defaultLink.value = window.location.href;
    }

    const [linksData, setLinksData] = useState([defaultLink]);

    const handleClose = () => {
        setLinksData([defaultLink]);
        setOpen(!open);
    };

    const addRow = () => {
        setLinksData(linksData.concat(getDefaultLinkData()));
    };

    const removeRow = (index) => {
        const _linksData = _.cloneDeep(linksData);
        _linksData.splice(index, 1);
        setLinksData(_linksData);
    };

    const modifyLinkData = (_type, tagData, index) => {
        const _linksData = _.cloneDeep(linksData);
        _linksData[index][_type] = tagData;
        setLinksData(_linksData);
    };

    const handleSave = async () => {
        api.createAnalyticsLinks(linksData)
            .then((response) => {
                if (!response.errors.length) {
                    addNotification({
                        title: 'Success',
                        message: 'Record/s created successfully',
                        level: 'success',
                        _id: new Date().getMilliseconds(),
                        autoDismiss: 3,
                    });
                    handleClose();
                    handleModifyLinksList && handleModifyLinksList();
                    handleSearch && handleSearch();
                } else {
                    addNotification({
                        title: 'Error',
                        message: response.errors[0].message || response.errors[0].messages[0],
                        level: 'error',
                        _id: new Date().getMilliseconds(),
                        autoDismiss: 3,
                    });
                }
            });
    };

    const actions = [
        <FlatButton
            label='Cancel'
            primary
            onClick={handleClose}
        />,
        <FlatButton
            label='Submit'
            primary
            keyboardFocused
            onClick={handleSave}
        />,
    ];

    return (
        <div>
            <Dialog 
                title={`${type} records`.toUpperCase()}
                open={open}
                actions={actions}
                onRequestClose={handleClose}
                className='identify-please'
            >
                {
                    toEdit ?
                        <LinkRow
                            type={type}
                            key='toEdit'
                            record={toEdit}
                        />
                        :
                        <Table 
                            selectable={false}
                            style={{ maxHeight: '300px', overflowY: 'auto' }}     
                        >
                            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                <TableHeaderColumn 
                                    style={{ ...styles.tableHeaderColumnCSS, width: '53%' }}
                                >
                                    Value
                                </TableHeaderColumn>
                                <TableHeaderColumn 
                                    style={{ ...styles.tableHeaderColumnCSS, width: '33%' }}
                                >
                                    Tags
                                </TableHeaderColumn>
                                <TableHeaderColumn />
                            </TableHeader>
                            <TableBody 
                                displayRowCheckbox={false}  
                            >
                                {
                                    linksData.map((record, index) => (
                                        <LinkRow
                                            type={type}
                                            record={record}
                                            index={index}
                                            key={`toAdd_${index}`}
                                            add={addRow}
                                            remove={removeRow}
                                            modifyLinkData={modifyLinkData}
                                        />
                                    ))
                                }
                            </TableBody>
                        </Table>
                }
            </Dialog>
        </div>
    );
}

export default connect(
    null,
    dispatch => bindActionCreators(
        {
            addNotification,
        },
        dispatch,
    ),
)(AddUpdateModal);


function LinkRow({
    key, record, index, add, remove, modifyLinkData, type, 
}) {
    return (
        <TableRow
            key={key}
        >
            <TableRowColumn 
                style={{ padding: 0, width: '53%' }}
            >
                <TextField
                    defaultValue={record.value}
                    floatingLabelText='Record'
                    onChange={e => modifyLinkData('value', e.target.value, index)}
                    style={{ width: '95%' }}
                    multiLine
                />
            </TableRowColumn>
            <TableRowColumn
                style={{ padding: 0, width: '33%', whiteSpace: 'unset' }}
            >
                <LinksTags 
                    tags={record.tags}
                    setTags={tags => modifyLinkData('tags', tags, index)}
                    placeHolder='Add tag'
                />
            </TableRowColumn>
            <TableRowColumn 
                style={{ ...styles.tableRowColumnSmallCSS, width: '12%' }} 
            >
                {
                    !index ?
                        <IconButton>
                            <ContentAddIcon
                                onClick={() => {
                                    add();
                                }}
                                style={{ margin: '70px 0 0 0' }}
                                color='green'
                            />
                        </IconButton>
                        :
                        <IconButton>
                            <ContentRemoveIcon
                                onClick={() => {
                                    remove(index);
                                }}
                                style={{ margin: '30px 0 0 0' }}
                                color='red'
                            />
                        </IconButton>
                }
            </TableRowColumn>
        </TableRow>
    );
}



// WEBPACK FOOTER //
// ./app/components/Analytics/AddUpdateModal.jsx